export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-Ver-1-18.0be5dcc4.png";